import React from "react";
import { Grid, TextField, Autocomplete, InputLabel } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
}));

const ProductMoreForm = (props) => {
  const {
    handleChange,
    product,
    overriddenEndorment,
    overriddenStyle,
    surchargeUpc1Options,
    isSurchargeUpc1Loading,
    handleChangeSurchargeUpc1Input,
    surchargeUpc2Options,
    isSurchargeUpc2Loading,
    handleChangeSurchargeUpc2Input,
  } = props;

  const classes = useStyles();

  return (
    <form margin="dense" noValidate autoComplete="off" className={classes.form}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("price_as_of", product),
            }}
            size="small"
            variant="outlined"
            label="Price As OF "
            name="price_as_of"
            value={product && product.price_as_of}
            onChange={handleChange}
            style={{
              background: overriddenStyle("price_as_of", product),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("api_department_id", product),
            }}
            size="small"
            variant="outlined"
            label="Department ID"
            name="api_department_id"
            value={product && product.api_department_id}
            onChange={handleChange}
            style={{
              background: overriddenStyle("api_department_id", product),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("api_department", product),
            }}
            size="small"
            variant="outlined"
            label="Department"
            name="api_department"
            value={product && product.api_department}
            style={{
              background: overriddenStyle("api_department", product),
            }}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("api_group_id", product),
            }}
            size="small"
            variant="outlined"
            label="Group ID "
            name="api_group_id"
            value={product && product.api_group_id}
            onChange={handleChange}
            style={{
              background: overriddenStyle("api_group_id", product),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("api_group", product),
            }}
            size="small"
            variant="outlined"
            label="Group "
            name="api_group"
            value={product && product.api_group}
            onChange={handleChange}
            style={{
              background: overriddenStyle("api_group", product),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("stock_level", product),
            }}
            size="small"
            variant="outlined"
            label="Stock Level"
            name="stock_level"
            value={product && product.stock_level}
            onChange={handleChange}
            style={{
              background: overriddenStyle("stock_level", product),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("on_order", product),
            }}
            size="small"
            variant="outlined"
            label="On Order"
            name="on_order"
            value={product && product.on_order}
            onChange={handleChange}
            style={{
              background: overriddenStyle("on_order", product),
            }}
          />
        </Grid>
        {/* <Grid item xs={12} sm={12}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              label="Next Delivery"
              value={selectedDatePayout && selectedDatePayout}
              renderInput={(props) => (
                <TextField
                  {...props}
                  label="Next Delivery date"
                  variant="standard"
                />
              )}
              onChange={handleDatePayoutChange}
              KeyboardButtonProps={{
                "aria-label": "next delivery date",
              }}
            />
          </LocalizationProvider>
        </Grid> */}
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Tag Main Description"
            name="tag_main_description"
            value={product && product.tag_main_description}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Tag Secondary Decription"
            name="tag_secondary_description"
            value={product && product.tag_secondary_description}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Reorder "
            name="reorder"
            value={product && product.reorder}
            onChange={handleChange}
          />
        </Grid>
        {/* <Grid item xs={12} sm={12}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              label="Last Sold"
              value={selectedDatePayout && selectedDatePayout}
              renderInput={(props) => (
                <TextField
                  {...props}
                  label="Last Sold date"
                  variant="standard"
                />
              )}
              onChange={handleDatePayoutChange}
              KeyboardButtonProps={{
                "aria-label": "last sold date",
              }}
            />
          </LocalizationProvider>
        </Grid> */}
        {/* <Grid item xs={12} sm={12}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              label="Last Delivery"
              value={selectedDatePayout && selectedDatePayout}
              renderInput={(props) => (
                <TextField
                  {...props}
                  label="Last Delivery date"
                  variant="standard"
                />
              )}
              onChange={handleDatePayoutChange}
              KeyboardButtonProps={{
                "aria-label": "last delivery date",
              }}
            />
          </LocalizationProvider>
        </Grid> */}
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="On Sale "
            name="on_sale"
            value={product && product.on_sale}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="New Status "
            name="new_status"
            value={product && product.new_status}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("weight", product),
            }}
            size="small"
            variant="outlined"
            label="Weight "
            name="weight"
            value={product && product.weight}
            onChange={handleChange}
            style={{
              background: overriddenStyle("weight", product),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("volume", product),
            }}
            size="small"
            variant="outlined"
            label="Volume "
            name="volume"
            value={product && product.volume}
            onChange={handleChange}
            style={{
              background: overriddenStyle("volume", product),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Pending Deletion "
            name="pending_deletion"
            value={product && product.pending_deletion}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Seasonal "
            name="seasonal"
            value={product && product.seasonal}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Temporarly Unavailable"
            name="temporarly_unavailable"
            value={product && product.temporarly_unavailable}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Special Order Item "
            name="special_order_item"
            value={product && product.special_order_item}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Primary UPC"
            name="primary_upc"
            value={product && product.primary_upc}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Sales Ranking"
            name="sales_ranking"
            value={product && product.sales_ranking}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Category ID"
            name="category_id"
            value={product && product.api_category}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputLabel shrink id="surchargeUpc1Label">
            Surcharge UPC 1
          </InputLabel>
          <Autocomplete
            fullWidth
            size="small"
            options={surchargeUpc1Options || []}
            getOptionLabel={(option) =>
              `${option.name} (${option.upc}) - ${option.item_code?.item_code || ""}`
            }
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                variant="standard"
                style={{ background: overriddenStyle("surcharge_upc1", product) }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {params.InputProps.endAdornment}
                      {overriddenEndorment("surcharge_upc1", product)}
                    </>
                  ),
                }}
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                {`${option.name} | (${option.upc}) #${
                  option.item_code?.item_code || ""
                }# Stock: ${option.stock_level || 0}`}
              </li>
            )}
            isOptionEqualToValue={(option, value) => option.upc === value.upc}
            loading={isSurchargeUpc1Loading}
            noOptionsText="Type at least 3 characters to search"
            onInputChange={handleChangeSurchargeUpc1Input}
            value={product?.surcharge_upc1_detail || null}
            onChange={(e, v) =>
              handleChange(
                {
                  target: {
                    checked: false,
                    name: "surcharge_upc1_detail",
                    value: product?.surcharge_upc1_detail,
                  },
                },
                v,
              )
            }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputLabel shrink id="surchargeUpc2Label">
            Surcharge UPC 2
          </InputLabel>
          <Autocomplete
            fullWidth
            size="small"
            options={surchargeUpc2Options || []}
            getOptionLabel={(option) =>
              `${option.name} (${option.upc}) - ${option.item_code?.item_code || ""}`
            }
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                variant="standard"
                style={{ background: overriddenStyle("surcharge_upc2", product) }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {params.InputProps.endAdornment}
                      {overriddenEndorment("surcharge_upc2", product)}
                    </>
                  ),
                }}
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                {`${option.name} | (${option.upc}) #${
                  option.item_code?.item_code || ""
                }# Stock: ${option.stock_level || 0}`}
              </li>
            )}
            isOptionEqualToValue={(option, value) => option.upc === value.upc}
            loading={isSurchargeUpc2Loading}
            noOptionsText="Type at least 3 characters to search"
            onInputChange={handleChangeSurchargeUpc2Input}
            value={product?.surcharge_upc2_detail || null}
            onChange={(e, v) =>
              handleChange(
                {
                  target: {
                    checked: false,
                    name: "surcharge_upc2_detail",
                    value: product?.surcharge_upc2_detail,
                  },
                },
                v,
              )
            }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("url", product),
            }}
            size="small"
            variant="outlined"
            label="URL"
            name="url"
            value={product && product.url}
            onChange={handleChange}
            style={{
              background: overriddenStyle("url", product),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
                readOnly: true,
              },
            }}
            size="small"
            variant="outlined"
            label="Item Code URL "
            name="url"
            value={product && product.item_code.url}
            style={{ background: "lightgray" }}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default ProductMoreForm;
